import { genTargetEvent, eventOptions } from './MaterialCreative'
import { uniqBy, cloneDeep, upperFirst } from 'lodash'

/**
 * 过滤默认相关交互事件的提示语(4无交互事件, 3不限)
 * @param {*} tipsDetail 提示语
 * @returns
 */
export function filterDefaultTips(tipsDetail) {
  if (tipsDetail) {
    const tipsList = JSON.parse(tipsDetail)
    const filteredList = tipsList.filter((item) =>
      [4, 3, undefined].includes(item.relatedTargetType)
    )
    return filteredList.length ? JSON.stringify(filteredList) : ''
  }
  return ''
}

/**
 * 从创意详情结果中赋值交互事件
 * @param model 包含ketEventList、autoEventList...的详情model
 * @param eventTempList 交互事件模板list
 * @param isBackup 是否打底交互
 * @returns { shipType: 'KEY', targetEventType: 1, targetEvent: { ... } }
 */
export function setTargetEventDetail(model, eventTempList = [], isBackup = false) {
  const retEvent = {
    shipType: 'NONE',
    targetEventType: 4,
    targetEvent: genTargetEvent()
  }
  eventOptions.some((item) => {
    const eventList = isBackup ? model['backup' + upperFirst(item.key)] : model[item.key]
    if (eventList && eventList[0] && eventList[0].targetTempId > -1) {
      const targetTemp = eventTempList.find(
        (item) => item.tempId === eventList[0].targetTempId
      )
      retEvent.shipType = item.shipType
      retEvent.targetEventType = targetTemp
        ? targetTemp.tempType
        : (eventList[0].targetTempId === 0 ? 1 : 4)
      retEvent.targetEvent = eventList[0]
      return true
    }
    return false
  })
  return retEvent
}

/**
 * 校验提示语
 * @param {*} tipsDetail 提示语详情
 * @returns
 */
export function checkTipsDetail(tipsDetail) {
  const tipsList = JSON.parse(tipsDetail)
  return tipsList.every((tip) => {
    if (tip.type === 'txt') {
      return (
        tip.showTime !== undefined &&
        tip.endTime !== undefined &&
        tip.marginX !== undefined &&
        tip.marginY !== undefined &&
        tip.content !== ''
      )
    }
    return (
      tip.showTime !== undefined &&
      tip.endTime !== undefined &&
      tip.marginX !== undefined &&
      tip.marginY !== undefined &&
      tip.content !== '' &&
      tip.width !== undefined &&
      tip.height !== undefined
    )
  })
}

/**
 * 校验交互事件
 * @param event 交互事件model
 * @returns 错误信息
 */
export function checkTargetEvent(event) {
  // 校验按键跳过de文案和显示时间
  if (event.targetTempId > -1 && event.normalData.doWhat === 'skipAd') {
    if (event.normalData.text === undefined || event.normalData.text === '') {
      return '按键跳过不能为空!'
    }
    if (event.normalData.text.indexOf('#K#') === -1) {
      return '按键跳过广告文案不合法，必须包含#K#!'
    }
    if (event.normalData.showTime === undefined || event.normalData.showTime === '') {
      return '显示时间不能为空!'
    }
  }

  // 校验扩展参数
  const paramsList = event.normalData.paramsList // 自定义模板的扩展参数
  const privateParams = event.normalData.privateParams // 自定义模板的扩展参数（私有）
  // 自定义模板的扩展参数校验
  if (event.targetTempId === 0) {
    if (paramsList.length > 0) {
      const paramErr = checkUniqArr(paramsList)
      if (paramErr) {
        return `扩展参数${paramErr}`
      }
    }
    if (privateParams.length > 0) {
      const priParamErr = checkUniqArr(privateParams)
      if (priParamErr) {
        return `扩展参数（私有）${priParamErr}`
      }
    }
  }

  const exParams = event.exceptionData.paramsList // 异常处理的扩展参数
  const exPriParams = event.exceptionData.privateParams // 异常处理的扩展参数（私有）
  // 异常处理的扩展参数校验
  if (event.targetTempId >= 0 && event.exception === 'yes') {
    if (exParams.length > 0) {
      const exParamErr = checkUniqArr(exParams)
      if (exParamErr) {
        return `异常处理扩展参数${exParamErr}`
      }
    }
    if (exPriParams.length > 0) {
      const exPriParamErr = checkUniqArr(exPriParams)
      if (exPriParamErr) {
        return `异常处理扩展参数（私有）${exPriParamErr}`
      }
    }
  }
}

function checkUniqArr(list = []) {
  const uniqList = uniqBy(list, 'key')
  return uniqList.length < list.length ? 'key不允许重复' : ''
}

/**
 * 校验监测代码
 * @param {*} model model
 * @param {*} landing 落地页监测传'Landing'
 * @param {*} macroMap 宏参map
 * @param {*} macroMap 监测商map
 * @returns error message
 */
export function checkTrackCode(model, landing = '', macroMap, providerMap, ownProvider) {
  const trackTypeList = [
    model[`trackList${landing}`],
    model[`clickTrackList${landing}`],
    model[`startTrackList${landing}`],
    model[`middleTrackList${landing}`],
    model[`endTrackList${landing}`],
    model[`pointTrackList${landing}`]
  ]

  let errorMsg = ''
  const existError = trackTypeList.some((tracks, index) => {
    const isPointTrack = index === 5
    errorMsg = checkTracks(tracks, macroMap, providerMap, ownProvider, isPointTrack)
    return !!errorMsg
  })
  if (existError) return errorMsg
}

function checkTracks(tracks = [], macroMap, providerMap, ownProvider, isPointTrack) {
  let coocaaCodeLen = 0
  for (const track of tracks) {
    if (ownProvider && track.serviceProvider === ownProvider.provider && !isPointTrack) {
      coocaaCodeLen += 1
    }
    track.code = track.code.replace(/\s|\n|\t/g, '')
    if (
      providerMap.has(track.serviceProvider) &&
      track.code.indexOf(providerMap.get(track.serviceProvider)) < 0
    ) {
      return '监测商与监测代码不对应!'
    }
    if (
      track.serviceProvider === '' ||
      track.trackTypeModel === '' ||
      track.code === ''
    ) {
      return '监测代码参数不完整!'
    }
    if (!checkRegEx(track.code)) return '监测代码格式有误!'
    const macroParams = macroMap[track.serviceProvider]
    if (macroParams && macroParams.length) {
      const containsMacro = macroParams.some((macroItem) =>
        track.code.includes(macroItem)
      )
      if (!containsMacro) return '监测代码未填入必填宏参!'
    }
  }
  if (coocaaCodeLen > 1) return `自有监测代码同一类型只能有一个!`
}

export function checkRegEx(trackCode) {
  let urlRegex = '^http[s]?:\\/\\/([\\w-]+\\.)+[\\w-]+([\\w-./?:@&=+$,%#-~]*)?$'
  let r = trackCode.match(urlRegex)
  if (r == null) return false
  return true
}

/**
 * 复制监测代码
 * @param {*} target 目标
 * @param {*} source 源
 */
export function shareTrackCode(target, source) {
  target.trackList = cloneDeep(source.trackList)
  target.clickTrackList = cloneDeep(source.clickTrackList)
  target.startTrackList = cloneDeep(source.startTrackList)
  target.middleTrackList = cloneDeep(source.middleTrackList)
  target.endTrackList = cloneDeep(source.endTrackList)
  target.pointTrackList = cloneDeep(source.pointTrackList)
}
